import { Box, Button, Image, Input, Text, Checkbox, useMediaQuery } from "@chakra-ui/react";
import { theme } from "../../styles/theme";
import logo from '../../assets/images/logo-white-orange.webp';
import greenLogo from '../../assets/images/logo-white-bg.webp';
import { useState, useEffect } from "react";
import { useAuth } from "../../Hooks/useAuth";
import { jwtDecode } from "jwt-decode";
import { api } from "../../services/api";
import swal  from 'sweetalert';
import { Link } from 'react-router-dom';
import { FaHome } from "react-icons/fa";
import { InputMask } from '../../components/InputMask'


export const userToken = () => window.localStorage.getItem("@app/token");
export function SignUp() {
  const { signUpUser, getUserInfo } = useAuth();
  const { errors } = useAuth();
  const isAuthenticated = () => userToken() !== null;
  const [userEmail, setUserEmail] = useState("");
  const [userPassword, setUserPassword] = useState("");
  const [userDocument, setUserDocument] = useState("");
  const [userName, setUserName] = useState("");
  const [userPhoneNumber, setUserPhoneNumber] = useState("");
  // const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const isMobile = useMediaQuery("(max-width: 767px)")[0];

  function handleUserSignUp(e) {
    e.preventDefault();
    localStorage.setItem("signup_origin", "newUser");
    signUpUser(userEmail, userPassword, userName, userDocument.replace(/[.-\s]/g, ''), userPhoneNumber.replace(/\D/g, ''))
  }

  function handleTogglePasswordVisibility(e) {
    e.preventDefault();
    const passwordInput = document.getElementById('password-input')
    if (e.target.checked) {
      passwordInput.type = "text"
    } else {
      passwordInput.type = "password"
    }
  }

  async function handleCallbackResponse(response) {
    let userObject = jwtDecode(response.credential);
    localStorage.setItem('userPhoto', userObject.picture);
    signInUserWithGoogleEmail(response.credential)
  }

  async function signInUserWithGoogleEmail(token) {
    const response = await api.get(`/api/v1/users/sign_in_with_google?id_token=${token}`);
    if (response.status === 200) {
      window.localStorage.setItem("@app/token", response.data.tokens["access-token"]);
      window.localStorage.setItem("@app/uid", response.data.tokens["uid"]);
      window.localStorage.setItem("@app/client", response.data.tokens["client"]);
      window.localStorage.setItem("@app/expiry", response.data.tokens["expiry"]);
      await getUserInfo(response.data.user);
      window.location.href = "/";
      if (typeof window !== "undefined") {
        if (window.fbq != null) {
          window.fbq('trackCustom', 'signInUserWithGoogleEmail');
        }
      }
    } else {
      swal({
        title: "Ops",
        text: "Ocorreu um erro no seu login, confira seus dados",
        icon: "error",
      });
    }
  }


  useEffect(() => {
    /* global google */
    google.accounts.id.initialize({
      client_id: "480318445952-v2iilvljfmm9jk2l9c1ldi66fkjfh06f.apps.googleusercontent.com",
      callback: handleCallbackResponse
    });

    google.accounts.id.renderButton(
      document.getElementById("signInDiv"),
      {theme: "outline", size: "large", text: "Cadastrar com Google"}
    )
  }, []);



 return (
  <Box
    minH="100vh"
    bg="#f8f8f8"
    display="flex"
    alignItems="center"
    justifyContent="center"
    p={{ base: 4, md: 8 }}
    position="relative"
  >
    <Link
      to="/"
      style={{
        position: "absolute",
        top: "24px",
        right: "24px",
        zIndex: 10
      }}
    >
      <Box
        bg="white"
        p="12px"
        borderRadius="full"
        boxShadow="0 4px 20px rgba(0,0,0,.08)"
      >
        <FaHome color="#004a33" />
      </Box>
    </Link>

    <Box
      maxW="1280px"
      w="100%"
      bg="white"
      borderRadius="24px"
      overflow="hidden"
      boxShadow="0 12px 40px rgba(0,0,0,.08)"
    >
      <Box
        display="flex"
        flexDirection={{ base: "column", lg: "row" }}
      >
        {/* COLUNA ESQUERDA */}
        <Box
          flex="1"
          bg="linear-gradient(135deg,#004a33,#006b4b)"
          color="white"
          p={{ md: 12 }}
          display={{ base: "none", lg: "flex" }}
          flexDirection="column"
          justifyContent="center"
        >
          <Image
            src={isMobile ? logo : logo}
            maxW="220px"
            mb="10"
            objectFit="contain"
          />

          <Text
            fontSize="48px"
            fontWeight="900"
            lineHeight="1.1"
          >
            Crie sua
            <br />
            Conta Zen
          </Text>

          <Text
            mt="6"
            opacity=".9"
            fontSize="18px"
            maxW="500px"
          >
            Cadastre-se gratuitamente e tenha acesso
            a ofertas exclusivas, acompanhamento de pedidos
            e uma experiência de compra personalizada.
          </Text>

          <Box mt="10">
            <Text mb="3">
              ✓ Ofertas Exclusivas
            </Text>

            <Text mb="3">
              ✓ Compra Segura
            </Text>

            <Text mb="3">
              ✓ Histórico de Pedidos
            </Text>

            <Text>
              ✓ Atendimento Humanizado
            </Text>
          </Box>
        </Box>

        {/* COLUNA DIREITA */}
        <Box
          flex="1"
          p={{ base: 6, md: 12 }}
        >
          <Image
            src={greenLogo}
            maxW="180px"
            mx="auto"
            mb="8"
            display={{ base: "block", lg: "none" }}
          />

          <Text
            fontSize={{ base: "32px", md: "40px" }}
            fontWeight="900"
            color="#004a33"
          >
            Criar Conta
          </Text>

          <Text
            color="gray.500"
            mt="2"
            mb="8"
          >
            Preencha seus dados para começar.
          </Text>

          <form onSubmit={(e) => handleUserSignUp(e)}>
            <Input
              placeholder="Seu e-mail"
              h="56px"
              mb="2"
              borderRadius="14px"
              onChange={(e) => setUserEmail(e.target.value)}
              autoComplete="current-email"
              _focus={{
                borderColor: "#fc8f04",
                boxShadow: "0 0 0 1px #fc8f04"
              }}
            />

            {errors.email && (
              <Text color="red.500" fontSize="sm" mb="3">
                {errors.email[0] === "is not an email"
                  ? "Email Inválido"
                  : errors.email[0]}
              </Text>
            )}

            <Input
              placeholder="Nome Completo"
              h="56px"
              mb="2"
              borderRadius="14px"
              onChange={(e) => setUserName(e.target.value)}
              autoComplete="current-name"
              _focus={{
                borderColor: "#fc8f04",
                boxShadow: "0 0 0 1px #fc8f04"
              }}
            />

            {errors.full_name && (
              <Text color="red.500" fontSize="sm" mb="3">
                {errors.full_name[0]}
              </Text>
            )}

            <Box mb="2">
              <InputMask
                maskType="cpf"
                placeholder="CPF"
                setUserDocument={setUserDocument}
              />
            </Box>

            {errors.document_number && (
              <Text color="red.500" fontSize="sm" mb="3">
                {errors.document_number[0]}
              </Text>
            )}

            <Box mb="2">
              <InputMask
                maskType="phone"
                placeholder="Celular"
                setUserPhoneNumber={setUserPhoneNumber}
              />
            </Box>

            {errors.phone_number && (
              <Text color="red.500" fontSize="sm" mb="3">
                {errors.phone_number[0]}
              </Text>
            )}

            <Input
              id="password-input"
              placeholder="Senha"
              type="password"
              h="56px"
              borderRadius="14px"
              mt="2"
              onChange={(e) => setUserPassword(e.target.value)}
              autoComplete="current-password"
              _focus={{
                borderColor: "#fc8f04",
                boxShadow: "0 0 0 1px #fc8f04"
              }}
            />

            {errors.password && (
              <Text color="red.500" fontSize="sm" mt="2">
                {errors.password[0]}
              </Text>
            )}

            <Checkbox
              mt="4"
              colorScheme="green"
              onChange={(e) => handleTogglePasswordVisibility(e)}
            >
              Mostrar senha
            </Checkbox>

            <Button
              mt="6"
              w="100%"
              h="56px"
              bg="#fc8f04"
              color="white"
              borderRadius="14px"
              fontWeight="700"
              type="submit"
              _hover={{
                bg: "#ea8100"
              }}
            >
              Criar Conta
            </Button>
          </form>

          <Box
            my="8"
            display="flex"
            justifyContent="center"
          >
            <div id="signInDiv"></div>
          </Box>

          <Box
            textAlign="center"
            pt="6"
            borderTop="1px solid"
            borderColor="gray.100"
          >
            <Text color="gray.600">
              Já possui uma conta?
            </Text>

            <Link
              to="/sign_in"
              style={{
                textDecoration: "none"
              }}
            >
              <Text
                mt="2"
                fontWeight="700"
                color="#fc8f04"
              >
                Fazer Login
              </Text>
            </Link>
          </Box>
        </Box>
      </Box>
    </Box>
  </Box>
);
}
